import { memo } from "react"
import styled from "styled-components"

const IconWrapper = styled.svg`
  position: absolute;
  top: 45px;
  right: -155px;
`

export const IconPlan = memo(() => {
  return (
    <IconWrapper xmlns="http://www.w3.org/2000/svg" width="333" height="333" viewBox="0 0 333 333" fill="none">
      <g opacity="0.1">
        <path
          d="M227.99 130.982L104.086 58.416"
          stroke="#6062CB"
          stroke-width="24.6875"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M227.969 130.983V274.59"
          stroke="#6062CB"
          stroke-width="24.6875"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M166.473 237.405L41.5977 166.504"
          stroke="#6062CB"
          stroke-width="24.6875"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M166.512 237.398L291.387 165.387"
          stroke="#6062CB"
          stroke-width="24.6875"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M104.086 130.427L228.961 58.416"
          stroke="#6062CB"
          stroke-width="24.6875"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M104.082 130.421V274.582"
          stroke="#6062CB"
          stroke-width="24.6875"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M45.4531 96.6362L166.471 166.497L287.475 96.6362"
          stroke="#6062CB"
          stroke-width="24.6875"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M166.508 166.504V306.225"
          stroke="#6062CB"
          stroke-width="24.6875"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M291.348 221.946V111.057C291.348 100.748 285.853 91.2297 276.932 86.0821L180.889 30.6376C171.967 25.4899 160.978 25.4899 152.057 30.6376L56.0138 86.0821C47.0922 91.2297 41.5977 100.748 41.5977 111.057V221.946C41.5977 232.255 47.0922 241.773 56.0138 246.921L152.057 302.366C160.978 307.513 171.967 307.513 180.889 302.366L276.932 246.921C285.853 241.773 291.348 232.255 291.348 221.946Z"
          stroke="#6062CB"
          stroke-width="24.6875"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
    </IconWrapper>
  )
})
